import React, { useMemo } from "react";
import "./styles.css";
import { Grid } from "@mui/material";
import Show from "../Show/Show"
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Summary from "../Summary";
import Homeownersection from "../HomeownerSection/Homeownersection";
import Footer from "../Footer/Footer";

export default function JobListAccordionComp(props) {
  const [expanded, setExpanded] = React.useState(false)
  const [showFooter, setshowFooter] = React.useState(false)

  const handleChange = (panel, status) =>
    (_, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
      if (isExpanded && status === 'Submitted' && props.Pagename === 'service') {
        setshowFooter(true)
      }
      else {
        setshowFooter(false)
      }

    }

  const handleFooter = (value) => {
    setshowFooter(value)
  }  

  const { JobStatus, Accordianlist } = props;

  return (
    <div style={{ marginTop: '1rem', width: '100%' }} className="JobList-accordionPg">
      <Grid>
        {Accordianlist?.map((item, index) => {
          return (
            <Accordion
              key={index}
              onChange={handleChange(index, item.status)}
              expanded={expanded === index}
              sx={{
                backgroundColor: "#F2F2F2",
                marginBottom: "4px",
                boxShadow: "none",
                borderRadius: "5px",
                border: "none",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon sx={{ color: "#0D5C75", fontSize: "32px" }} />
                }
                aria-controls="panel1a-content"
                sx={{ width: '100%' }}
              >
                <Summary item={item} name={props.Pagename} />
              </AccordionSummary>
              <AccordionDetails style={{ padding: '0px' }}>
                {props.Pagename === 'service' ? (<Show item={item} name={props.Pagename} />) : (<Homeownersection item={item} name={props.Pagename} />)

                }
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Grid>
      {!showFooter ? null : (<Footer handleFooter = {handleFooter}/>)}
    </div>
  );
}
